import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useMemo } from "react";
import CheckoutForm from "../checkout/CheckoutForm";
import { useAuth0 } from "@auth0/auth0-react";

const RightContent = () => {
  const { user } = useAuth0();
  const stripePromise = useMemo(() => {
    return loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string);
  }, []);

  return (
    <div className="u-w-all u-background--white u-flex u-flex-center u-align-center">
      <Elements stripe={stripePromise}>
        <CheckoutForm
          customerId={user?.sub}
          promoCode=""
          userEmail={user?.email || ""}
          hideHeaderText={true}
        />
      </Elements>
    </div>
  );
};

export default RightContent;
